import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import theme from "./styles/theme";
import { Provider, rootStore } from "./mobx/";
import { CssBaseline, ThemeProvider } from "@mui/material";
import "katex/dist/katex.min.css";
import { SnackbarProvider } from "notistack";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
	<Provider value={rootStore}>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<SnackbarProvider maxSnack={3}>
				<App />
			</SnackbarProvider>
		</ThemeProvider>
	</Provider>
);
